import { Component, OnInit, Input } from '@angular/core';
import { Labels } from '../app.models';
import { UtilsService } from '../services/utils.service';
import { Observable } from 'rxjs';
import { DialogService } from '../services/dialog.service';
import { EternalLinkDialogComponent } from '../shared/external-link-dialogs/external-link-dialog.component';

@Component({
    selector: 'app-customer-support',
    templateUrl: './customer-support.component.html',
    styleUrls: ['./customer-support.component.scss'],
    standalone: false
})
export class CustomerSupportComponent implements OnInit {
  isMobile$: Observable<boolean>;

  private _labels: Labels;
  private _displayMobile: boolean = false;
  public get displayMobile() {
    return this._displayMobile;
  }

  @Input() public set labels(labels: Labels) {
    this._labels = labels;
  }
  public get labels() {
    return this._labels;
  }

  constructor(
    private dialogService: DialogService,
    private utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.isMobile$ = this.utilsService.isMobile;
  }

  toggleSupportMobile() {
    this._displayMobile = !this._displayMobile;
    const custSupport = document.getElementById('customer-support-container');
    if (this._displayMobile) {
      setTimeout(() => {
        custSupport?.scrollIntoView();
      }, 100);
    }
  }

  openDialog(url: string | undefined) {
    this.dialogService.open(EternalLinkDialogComponent, {
      data: {
        url,
      },
      ariaLabel: 'title',
      role: 'alertdialog',
    });
    return false;
  }
}
